<script>
export default {
  name: 'admin',
  data() {
    return {
      username: localStorage.getItem('name'),
      loading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      isUsername: false,
      admin: {
        username: "",
        password: "",
        name: "",
        reserve1: ""
      },
      dialogVisible: false
    }
  },
  mounted() {
    if (localStorage.getItem('jurisdiction') != "管理员") {
      this.$router.push({name: 'no'})
    }
    this.getAdmin()
  },
  methods: {
    // 获取数据
    getAdmin() {
      this.loading = true
      this.$axios.get("/admin/admin", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getAdmin()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getAdmin()
    },
    // 打开对话框
    edit(e) {
      this.isUsername = true
      this.dialogVisible = true
      this.admin.username = e.username
      this.admin.password = e.password
      this.admin.name = e.name
      this.admin.reserve1 = e.reserve1
    },
    close() {
      this.isUsername = false
      this.dialogVisible = false
      this.admin.username = ""
      this.admin.password = ""
      this.admin.name = ""
      this.admin.reserve1 = ""
    },
    setAdmin() {
      this.$axios.post("/admin/admin", this.admin).then((res) => {
        this.$message.success("修改成功")
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "管理员管理",
          "name": this.username,
          "content": "修改了'" + this.admin.username + "'的管理员信息"
        })
        this.getAdmin()
        this.close()
      }).catch((r) => {
        this.$message.error("修改失败")
      })
    },
    deleteAdmin(e) {
      this.$confirm('此操作将永久删除管理员：' + e.username + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete("/admin/admin/" + e.username).then((res) => {
          this.$message.success('删除成功!')
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "管理员管理",
            "name": this.username,
            "content": "删除了'" + e.username + "'的管理员信息"
          })
          this.getAdmin()
        }).catch((e) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      });
    },
    out() {
      this.$router.push({name: 'login'})
    },
  }
}
</script>

<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      <el-button type="primary" class="topInput" @click="dialogVisible=true">添加管理员</el-button>
    </el-header>

    <el-main>
      <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          border
          highlight-current-row
          current-row-key="id"
          max-height="500">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="账号" align="center" width="200">
        </el-table-column>
        <el-table-column prop="password" label="密码" align="center" width="200">
          <template slot-scope="scope">
            *******
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center" width="120">
        </el-table-column>
        <el-table-column prop="reserve1" label="备注" align="center" width="300">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="medium">编辑</el-button>
            <el-button @click="deleteAdmin(scope.row)" type="text" size="medium">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="el-footer" id="page">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :pager-count="11"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-footer>

    <el-dialog title="编辑管理员" :visible.sync="dialogVisible">
      <el-form :model="admin" :inline="true">
        <el-form-item label="账号">
          <el-input :disabled="isUsername" v-model="admin.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="55px">
          <el-input v-model="admin.password"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="admin.name"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="admin.reserve1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="setAdmin()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
}

.el-form .el-form-item {
  margin: 10px;
}

.el-main {
  margin-left: 25px;
}

.el-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/adminView.vue